// Deprecated legacy handoff entry point; remove after Rampage migrates.
// Games and apps that want to "Sign in with Argus Auth" open this route in a popup (preferably using the SDK)
// This route then creates a new service auth session (`sessionId`), then redirects to authorize route
// carrying the `sessionId`, authorize then eventually sends the JWT to the opener
// Optional: pass `clientAppName` in the search params, to identify the game/app trying to sign in

import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { authClient } from '@/lib/auth-client'
import { notifyOpenerOnError } from '@/lib/notify-opener'

export const Route = createFileRoute('/new-auth-session')({
  validateSearch: z.object({
    clientAppName: z.string().optional(),
  }),
  component: NewAuthSessionError,
  beforeLoad: async ({ search }) => {
    const { data, error } = await authClient.serviceAuthSession({
      clientAppName: search.clientAppName,
      fetchOptions: {
        method: 'POST',
      },
    })

    if (error) {
      notifyOpenerOnError(error.message ?? error.statusText)
      return // let it load the NewAuthSessionError component
    }

    throw redirect({ href: data.clientUrl })
  },
})

function NewAuthSessionError() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.close()
    }, 5000)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <div className="mt-16 flex flex-col gap-4 items-center justify-center">
      <p className="text-lg font-medium">
        Error attempting to Sign in with Argus Auth. Please try again.
      </p>
      <p className="text-sm text-gray-500">
        You can close this tab now, or it will close automatically in 5 seconds.
      </p>
    </div>
  )
}
